import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Dotcom2024Service } from '../../dotcom2024.service';
import { environment } from '../../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { MyharrellsService } from '../../myharrells.service';
import { CustomerformComponent } from "../../customerform/customerform.component";
import { BlogsbymarketpageComponent } from "../../blogsbymarketpage/blogsbymarketpage.component";


@Component({
    selector: 'app-specialty',
    standalone: true,
    templateUrl: './specialty.component.html',
    styleUrl: './specialty.component.css',
    imports: [CommonModule, FormsModule, CustomerformComponent, BlogsbymarketpageComponent]
})
export class SpecialtyComponent {
  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public router: Router, public route: ActivatedRoute) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Markets/";
  productImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/ProductPhotos/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";


  filePath: string = environment.azureBlobStorageURL + environment.baseFilesPathBlobStorage;

  featuredProducts: any[] = [];
  featuredProduct1ItemNmbr: string = "";
  featuredProduct2ItemNmbr: string = "";
  featuredProduct3ItemNmbr: string = "";
  featuredProduct4ItemNmbr: string = "";
  featuredProduct1ProductName: string = "";
  featuredProduct2ProductName: string = "";
  featuredProduct3ProductName: string = "";
  featuredProduct4ProductName: string = "";

  featuredBlogs: any[] = [];
  featuredBlog1ImageName: string = "";
  featuredBlog2ImageName: string = "";
  featuredBlog3ImageName: string = "";
  featuredBlog1Title: string = "";
  featuredBlog2Title: string = "";
  featuredBlog3Title: string = "";
  featuredBlog1Summary: string = "";
  featuredBlog2Summary: string = "";
  featuredBlog3Summary: string = "";


  imageExists: boolean = false;

  ngOnInit(): void {
    this.dotComService.activePage = "specialty"

    this.title.setTitle("Specialty Agriculture Controlled-Release Fertilizer");
    this.meta.updateTag({ name: 'description', content: "Harrell`s manufactures and distributes POLYON® controlled-release fertilizer to fee the success of specialty agriculture farmers." });
    this.meta.updateTag({ property: 'og:title', content: "Specialty Agriculture Controlled-Release Fertilizer" });
    this.meta.updateTag({ property: 'og:description', content: "Harrell`s manufactures and distributes POLYON® controlled-release fertilizer to fee the success of specialty agriculture farmers." });
    this.meta.updateTag({ property: 'Twitter:title', content: "Specialty Agriculture Controlled-Release Fertilizer" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Harrell`s manufactures and distributes POLYON® controlled-release fertilizer to fee the success of specialty agriculture farmers." });

    //get the 4 items to display
    this.GetFeaturedItemsToDisplay('specialty');
    // this.GetFeaturedBlogsToDisplay('golf');

  }

  GetFeaturedItemsToDisplay(marketPage: string) {
    this.featuredProducts = []
    this.dotComService.GetMarketsFeaturedProducts(marketPage).subscribe((data: any) => {
      this.featuredProducts = data;
      this.PopulateFeaturedProductsVariables();
    })
  }

  NextFeaturedProduct(){
    //shuffle the array so the first item moves to the last
    let firstItem = this.featuredProducts[0];
    this.featuredProducts.shift();
    this.featuredProducts.push(firstItem);

    //reload the variables the html uses to dixplay the products
    this.PopulateFeaturedProductsVariables();
  }

  PreviousFeaturedProduct(){
     //shuffle the array so the last item moves to the first
     let lastItem = this.featuredProducts[this.featuredProducts.length - 1];
     this.featuredProducts.pop();
     this.featuredProducts.unshift(lastItem);

     //reload the variables the html uses to dixplay the products
     this.PopulateFeaturedProductsVariables();
  }

  PopulateFeaturedProductsVariables(){
    this.featuredProduct1ItemNmbr = ""
    this.featuredProduct2ItemNmbr = ""
    this.featuredProduct3ItemNmbr = ""
    this.featuredProduct4ItemNmbr = ""

    for (let i = 0; i < this.featuredProducts.length; i++) {
      if (this.featuredProduct1ItemNmbr == "") {
        this.featuredProduct1ItemNmbr = this.featuredProducts[i].ItemNmbr;
        this.featuredProduct1ProductName = this.featuredProducts[i].WebName;
      } else if (this.featuredProduct2ItemNmbr == "") {
        this.featuredProduct2ItemNmbr = this.featuredProducts[i].ItemNmbr;
        this.featuredProduct2ProductName = this.featuredProducts[i].WebName;
      } else if (this.featuredProduct3ItemNmbr == "") {
        this.featuredProduct3ItemNmbr = this.featuredProducts[i].ItemNmbr;
        this.featuredProduct3ProductName = this.featuredProducts[i].WebName;
      } else if (this.featuredProduct4ItemNmbr == "") {
        this.featuredProduct4ItemNmbr = this.featuredProducts[i].ItemNmbr;
        this.featuredProduct4ProductName = this.featuredProducts[i].WebName;
      }
    }
  }

  // GetFeaturedBlogsToDisplay(marketPage: string) {
  //   this.featuredBlogs = []
  //   this.dotComService.GetMarketsFeaturedBlogs(marketPage).subscribe((data: any) => {
  //     this.featuredBlogs = data;
  //     this.PopulateFeaturedBlogVariables();
  //   })
  // }

  // NextFeaturedBlog(){
  //   //shuffle the array so the first item moves to the last
  //   let firstItem = this.featuredBlogs[0];
  //   this.featuredBlogs.shift();
  //   this.featuredBlogs.push(firstItem);

  //   //reload the variables the html uses to dixplay the products
  //   this.PopulateFeaturedBlogVariables();
  // }

  // PreviousFeaturedBlog(){
  //    //shuffle the array so the last item moves to the first
  //    let lastItem = this.featuredBlogs[this.featuredBlogs.length - 1];
  //    this.featuredBlogs.pop();
  //    this.featuredBlogs.unshift(lastItem);

  //    //reload the variables the html uses to dixplay the products
  //    this.PopulateFeaturedBlogVariables();
  // }

  // PopulateFeaturedBlogVariables(){
  //   this.featuredBlog1Title = ""
  //   this.featuredBlog2Title = ""
  //   this.featuredBlog3Title = ""

  //   for (let i = 0; i < this.featuredBlogs.length; i++) {
  //     if (this.featuredBlog1Title == "") {
  //       this.featuredBlog1Title = this.featuredBlogs[i].Title;
  //       this.featuredBlog1Summary = this.featuredBlogs[i].Summary;

  //       //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
  //       this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg", (exists) => {
  //         if (exists) {
  //           // Success code
  //           //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
  //           this.featuredBlog1ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg";
  //         } else {
  //           // Fail code
  //           this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png", (exists) => {
  //             if (exists) {
  //               // Success code
  //               this.featuredBlog1ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png";
  //             } else {
  //               // Fail code - use default
  //               this.featuredBlog1ImageName = this.baseImagePaths + "harrellsh.png"
  //             }
  //           })
  //         }
  //       });


  //     } else if (this.featuredBlog2Title == "") {
  //       this.featuredBlog2Title = this.featuredBlogs[i].Title;
  //       this.featuredBlog2Summary = this.featuredBlogs[i].Summary;

  //       //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
  //       this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg", (exists) => {
  //         if (exists) {
  //           // Success code
  //           //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
  //           this.featuredBlog2ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg";
  //         } else {
  //           // Fail code
  //           this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png", (exists) => {
  //             if (exists) {
  //               // Success code
  //               this.featuredBlog2ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png";
  //             } else {
  //               // Fail code - use default
  //               this.featuredBlog2ImageName = this.baseImagePaths + "harrellsh.png"
  //             }
  //           })
  //         }
  //       });


  //     } else if (this.featuredBlog3Title == "") {
  //       this.featuredBlog3Title = this.featuredBlogs[i].Title;
  //       this.featuredBlog3Summary = this.featuredBlogs[i].Summary;

  //       //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
  //       this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg", (exists) => {
  //         if (exists) {
  //           // Success code
  //           //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
  //           this.featuredBlog3ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg";
  //         } else {
  //           // Fail code
  //           this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png", (exists) => {
  //             if (exists) {
  //               // Success code
  //               this.featuredBlog3ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png";
  //             } else {
  //               // Fail code - use default
  //               this.featuredBlog3ImageName = this.baseImagePaths + "harrellsh.png"
  //             }
  //           })
  //         }
  //       });
  //     }
  //   }
  // }

  ViewRelatedProductDetail(productID: any) {
    this.router.navigateByUrl('/product?sku=' + productID);
  }

}
